var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorder3BottomLeft = function SvgBorder3BottomLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v19.5c0 16.569 13.431 30 30 30h134.5",
    stroke: "#000"
  })));
};

export default SvgBorder3BottomLeft;